export default __webpack_public_path__ + "static/media/346.1c1eb2ed.png";